const STAFF_ROLES = ['super_admin', 'front_desk'] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export function isStaffRole(role: string | undefined | null): role is StaffRole {
  return role === 'super_admin' || role === 'front_desk';
}

export function isSuperAdmin(role: string | undefined | null): boolean {
  return role === 'super_admin';
}

export function isPlatformAdmin(role: string | undefined | null): boolean {
  return role === 'platform_admin';
}
